import React from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';

/**
 * Reusable checkbox using MUI. Styled via theme (primary color when checked).
 * Use for "Remember me", Terms agreement, etc.
 */
const Checkbox = ({
  name,
  label,
  checked = false,
  onChange,
  value,
  required = false,
  disabled = false,
  labelPlacement = 'end',
  inputProps,
  ...rest
}) => {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          name={name}
          checked={checked}
          onChange={onChange}
          value={value}
          disabled={disabled}
          required={required}
          inputProps={inputProps}
          {...rest}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
      disabled={disabled}
    />
  );
};

export default Checkbox;
